module.exports = __webpack_public_path__ + "img/passwordIcon.64ecd579.svg";